import { render, staticRenderFns } from "./QuestionRenderer.vue?vue&type=template&id=849ebcbe&scoped=true&"
import script from "./QuestionRenderer.vue?vue&type=script&lang=js&"
export * from "./QuestionRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849ebcbe",
  null
  
)

export default component.exports